// src/multiselect/src/components/react-select-components/select-container.tsx
import { components } from "react-select";
import { jsx } from "react/jsx-runtime";
var SelectContainer = ({
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsx(components.SelectContainer, { ...props, children });
};

export {
  SelectContainer
};
